import { Tooltip, Typography } from '@mui/material'

const EducationTooltip = ({ title, children }) => (
  <Tooltip
    title={
      <Typography variant="body2" sx={{ color: '#ffffff', p: 1 }}>
        {title}
      </Typography>
    }
    arrow
    placement="top"
  >
    <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#8a4fff' }}>
      {children}
    </span>
  </Tooltip>
)

const getEducationMessages = () => ({
  portfolioYield: 'This is the weighted average yield of your portfolio, showing the annual dividend return as a percentage of your investment.',
  endOfYearValue: 'This shows your total portfolio value at the end of the year, including your initial investment plus the dividends earned.',
  strategy: 'Aggressive strategies prioritize high-yield stocks (often with higher risk), balanced strategies mix moderate yields, and safe strategies focus on low-yield, low-risk stocks.'
})

export { EducationTooltip, getEducationMessages }